import Avatar, { type AvatarProps } from "@mui/material/Avatar";
import { SvgFileIcon } from "core/components/SvgFileIcon";

export function FileAvatar({
  fileName,
  ...avatarProps
}: { fileName: string } & AvatarProps) {
  return (
    <Avatar
      {...avatarProps}
      sx={{
        bgcolor: "divider",
        color: (theme) => theme.palette.text.secondary,
        "&:hover": { cursor: "pointer" },
        ...avatarProps.sx,
      }}
    >
      <SvgFileIcon fileName={fileName} />
    </Avatar>
  );
}
